const navData = {
  nav_data: [
    {
      name: "Home",
      href: "home",
    },
    {
      name: "About",
      href: "about",
    },
    {
      name: "EXPERIENCE",
      href: "resume",
    },
    {
      name: "Skills",
      href: "skills",
    },
    {
      name: "Status",
      href: "status",
    },
    // {
    //   name: "Works",
    //   href: "portfolio",
    // },
    {
      name: "My Favourite Quotes",
      href: "testimonials",
    },
    {
      name: "Contact",
      href: "contact",
    },
  ],
};

export default navData;
